import { MessageCircle, Zap, Handshake, type LucideIcon } from 'lucide-react';
import { Card } from '../../ui';

const iconMap: Record<string, LucideIcon> = {
    MessageCircle,
    Zap,
    Handshake,
};

export interface FeatureCardProps {
    icon: string;
    title: string;
    description: string;
}

export function FeatureCard({ icon, title, description }: FeatureCardProps) {
    const IconComponent = iconMap[icon] || MessageCircle;

    return (
        <Card variant="default" className="text-center bg-white border border-gray-100 hover:border-main-color/30 transition-all hover:shadow-lg">
            <div className="flex flex-col items-center">
                {/* Icon */}
                <div className="w-16 h-16 rounded-full bg-main-color/10 flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-main-color" />
                </div>

                {/* Title */}
                <h3 className="font-font-s font-bold text-text-color text-lg mb-3">{title}</h3>

                {/* Description */}
                <p className="font-font-s text-gray-600 text-sm leading-relaxed">{description}</p>
            </div>
        </Card>
    );
}
